/**
 * Skript slouží pro ajaxové zpracování odkazů
 *
 * Zapnutí se provádí importem souboru. Defaultně v takovém případe hledáme prvky s atributem
 * data-spinao-ajax="link"
 *
 * PŘÍKLAD:
 * import '../assets-base/assets-src/js/Spinao/NetteAjaxLink';
 *
 * V případě potřeby je možné soubor importovat do namespace a nastavit vlastní selector
 * pro identifikaci formulářů které mají být zpracovány ajaxem
 *
 * PŘÍKLAD:
 * import * as NetteAjaxLink '../assets-base/assets-src/js/Spinao/NetteAjaxLink';
 *
 * document.addEventListener("DOMContentLoaded", function() {
 *    NetteAjaxLink.initialize('.ajaxoveOdkazy');
 * });
 */
import * as NetteAjax from './NetteAjax';

export function applyTo(selector) {
    document.addEventListener('click', function(event) {
        let target = event.target || event.srcElement;

        while(target !== null && target.matches(selector) === false) {
            target = target.parentElement;
        }

        if(target) {
            console.log('999');
            event.preventDefault();
            processLink(target);
        }
    });
}

function processLink(link)
{
    return NetteAjax.sendRequest(
        {
            url: link.getAttribute('href')
        }
    );
}

document.addEventListener("DOMContentLoaded", function() {
    applyTo('[data-spinao-ajax="link"]');
});
